// Pure helpers for the brief detail property grid. Extracted so they're
// trivially unit-testable and so the route file stays JSX-only.

/** Format the agency cell as "Canonical Name (ABBR)" when both exist, else
 * canonical alone, else the raw payload name, else null. Mirrors the
 * displayedAgency precedence used in metrics so the property grid and the
 * header header stay consistent. */
export function agencyDisplayLabel(opp: {
  agency_canonical_name?: string | null;
  agency_raw_name: string | null;
  agency_abbreviation?: string | null;
}): string | null {
  const name = opp.agency_canonical_name ?? opp.agency_raw_name ?? null;
  if (!name) return null;
  const abbr = opp.agency_abbreviation?.trim();
  if (abbr && !name.toLowerCase().includes(abbr.toLowerCase())) {
    return `${name} (${abbr})`;
  }
  return name;
}

/** Returns true if expected_start_date is meaningfully different from the
 * row's "creation" anchors (publication_date and fetched_at). Youssef flagged
 * that for many rows the scraper populates expected_start_date with the
 * publication / fetched timestamp, so the field reads as misleading.
 *
 * Compare on the date-only slice (first 10 chars of an ISO date) — both
 * tenders.publication_date and tenders.expected_start_date are stored as
 * dates; fetched_at is a timestamptz but the date slice is robust to
 * clock-skew within the same UTC day, which is the tolerance we want.
 *
 * Returns false (hide) when expected_start equals either anchor. */
export function shouldShowExpectedStart(
  expectedStart: string | null | undefined,
  publicationDate: string | null | undefined,
  fetchedAt: string | null | undefined,
): boolean {
  if (!expectedStart) return false;
  const day = (s: string | null | undefined) => (s && s.length >= 10 ? s.slice(0, 10) : null);
  const es = day(expectedStart);
  if (!es) return false;
  const pub = day(publicationDate);
  const fetched = day(fetchedAt);
  if (pub && pub === es) return false;
  if (fetched && fetched === es) return false;
  return true;
}
